import Vue from 'vue';
import App from '../vue/App.vue';

export default {
  init() {
    // JavaScript to be fired on the home page
    window.vm = new Vue({
      el: 'app',
      components: {
        App,
      },
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js